/* KIRIBAN shared audio. Exposes window.KBAudio. Safe to load more than once. */
(function () {
  "use strict";
  if (window.KBAudio) return;
  var ac = null, on = false;
  function ctx() {
    if (ac === null) { try { ac = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) { ac = false; } }
    return ac;
  }
  function env(n, a, d, p) {
    var c = ctx(); if (!c) return;
    var g = c.createGain();
    g.gain.setValueAtTime(0.0001, c.currentTime);
    g.gain.exponentialRampToValueAtTime(p, c.currentTime + a);
    g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + a + d);
    n.connect(g); g.connect(c.destination);
  }
  function noise(d) {
    var c = ctx(), n = c.sampleRate * d, b = c.createBuffer(1, n, c.sampleRate), a = b.getChannelData(0);
    for (var i = 0; i < n; i++) a[i] = (Math.random() * 2 - 1) * (1 - i / n);
    var s = c.createBufferSource(); s.buffer = b; return s;
  }
  var API = {
    isOn: function () { return on; },
    toggle: function () {
      on = !on;
      if (on) { var c = ctx(); if (c && c.state === "suspended") c.resume(); API.bell(); }
      return on;
    },
    bell: function () {
      var c = ctx(); if (!c || !on) return;
      [1, 2.76, 5.4].forEach(function (r, i) {
        var o = c.createOscillator(); o.type = "sine"; o.frequency.value = 784 * r;
        env(o, 0.004, 2.2 - i * 0.5, 0.15 / (i + 1)); o.start(); o.stop(c.currentTime + 2.6);
      });
    },
    shutter: function (up) {
      var c = ctx(); if (!c || !on) return;
      var s = noise(up ? 1.2 : 0.45), f = c.createBiquadFilter();
      f.type = "lowpass";
      f.frequency.setValueAtTime(up ? 380 : 900, c.currentTime);
      f.frequency.exponentialRampToValueAtTime(up ? 1500 : 160, c.currentTime + (up ? 1.05 : 0.4));
      var g = c.createGain(); g.gain.value = up ? 0.09 : 0.16;
      s.connect(f); f.connect(g); g.connect(c.destination); s.start();
    },
    tick: function (hz, v) {
      var c = ctx(); if (!c || !on) return;
      var o = c.createOscillator(); o.type = "square"; o.frequency.value = hz || 1150;
      env(o, 0.001, 0.032, v || 0.05); o.start(); o.stop(c.currentTime + 0.06);
    }
  };
  window.KBAudio = API;

  function bindToggle() {
    var b = document.querySelector("[data-kb-sound]");
    if (!b || b.dataset.kbBound) return;
    b.dataset.kbBound = "1";
    b.addEventListener("click", function () { b.setAttribute("aria-pressed", String(API.toggle())); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bindToggle);
  else bindToggle();
})();
